import React, { useEffect, useState, useRef } from "react";
import { Table, Input, Button, Form, Col, Row, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../assets/back-icon.svg";

import { useDispatch, useSelector } from "react-redux";

import _ from "lodash";

import { fetchReportBatches } from "./redux/actions";
import { useParams } from "react-router-dom";

const { Option } = Select;

const HistoryView = ({ canUpdate = true, canDelete = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [search, setSearch] = useState({});
  const [req, setReq] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();

  const { reportBatches, loading } = useSelector(
    (state) => state.reportBatchesReducer
  );
  const [debouncedCallApi] = useState(() =>
    _.debounce(() => setReq((prev) => !prev), 500)
  );

  useEffect(() => {
    dispatch(fetchReportBatches());
  }, []);

  // const handleSearch = (key, value, func = null) => {
  //   let updatedState = {
  //     ...search,
  //     [key]: value,
  //   };

  //   // setSearch(updatedState);

  //   // if (typeof func === "function") {
  //   //   func();
  //   // }

  //   // dispatch(setStorage({ search: updatedState }));
  //   // handleSetStorage("search", updatedState);
  // };

const selectedBatch = reportBatches?.find((b) => b._id === id);

  const filteredData =
    selectedBatch?.reports?.filter((item) => {
      const studentMatch = search.student_name
        ? item.student_name?.toLowerCase().includes(search.student_name.toLowerCase())
        : true;
      const urlMatch = search.url
        ? item.url?.toLowerCase().includes(search.url.toLowerCase())
        : true;
      return studentMatch && urlMatch;
    }) || [];

  const handleSearch = (key, value, func = null) => {
    let updatedState = {
      ...search,
      [key]: value,
    };

    setSearch(updatedState);

    if (typeof func === "function") {
      func();
    }
  };

  const searchInput = (key) => (
    <Input
      onClick={(e) => e.stopPropagation()}
      value={search[key]}
      onChange={(e) => {
        handleSearch(key, e.target.value, debouncedCallApi);
      }}
    />
  );

  // const filteredData =
  //   selectedBatch?.reports?.filter((item) =>  {
  //     const studentMatch = search.student_name
  //       ? item.student_name
  //           ?.toLowerCase()
  //           .includes(search.student_name.toLowerCase())
  //       : true;

  //     const urlMatch = search.url
  //       ? item.url?.toLowerCase().includes(search.url.toLowerCase())
  //       : true;

  //     return studentMatch && urlMatch;
  //   }) || [];

  const columns = [
    // {
    //   title: () => (
    //     <div align="top" style={{ width: "100%" }}>
    //       <div className="special-table-header-text">Class</div>
    //       <div>{searchInput("class")}</div>
    //     </div>
    //   ),
    //   dataIndex: "class",
    //   key: "class",
    //   width: "15%",
    //   sorter: (a, b) =>
    //     (a.class?.name ?? "")
    //       .toLowerCase()
    //       .localeCompare((b.class?.name ?? "").toLowerCase()),
    //   render: (cls) => (
    //     <div style={{ paddingLeft: "12px" }}>
    //       {cls?.name ? `${cls.name} (${cls.code})` : "-"}
    //     </div>
    //   ),
    // },

    // {
    //   title: () => (
    //     <div align="top" style={{ width: "100%" }}>
    //       <div className="special-table-header-text">Student</div>
    //       <div>{searchInput("name")}</div>
    //     </div>
    //   ),
    //   dataIndex: "name",
    //   key: "name",
    //   width: "15%",
    //   sorter: (a, b) =>
    //     `${a?.name?.first_name} ${a?.name?.last_name}`.localeCompare(
    //       `${b?.name?.first_name} ${b?.name?.last_name}`
    //     ),
    //   render: (_, record) => (
    //     <div>
    //       {record?.name?.first_name} {record?.name?.last_name}
    //     </div>
    //   ),
    // },

    {
      title: () => (
        <div align="top" style={{ width: "100%" }}>
          <div className="special-table-header-text">Student</div>
          <div>{searchInput("student_name")}</div>
        </div>
      ),
      dataIndex: "student_name",
      key: "student_name",
      width: "auto",
      sorter: (a, b) => a.student_name?.localeCompare(b.student_name),
      render: (name) => <div style={{ paddingLeft: "12px" }}>{name}</div>,
    },

    {
      title: () => (
        <div align="top" style={{ width: "100%" }}>
          <div className="special-table-header-text">Report URL</div>
          <div>{searchInput("url")}</div>
        </div>
      ),
      dataIndex: "url",
      key: "url",
      width: "auto",

      render: (url) =>
        url ? (
          <a href={url} target="_blank" rel="noopener noreferrer">
            {url.length > 100 ? url.slice(0, 50) + "..." : url}
          </a>
        ) : (
          "-"
        ),
      sorter: (a, b) => a.url?.localeCompare(b.url),
    },
  ];

  return (
    <div className="page-top-div">
      <span className="text-span">Report History View</span>
      <Button
        style={{ position: "absolute", right: "15mm", marginBottom: 20 }}
        onClick={() => navigate(-1)}
        icon={<BackIcon width={24} height={14} />}
      >
        Back
      </Button>
      <Row justify="center" className="production-manager-parent-row">
        <Col xxl={24} xl={24} lg={24} md={24} className="heading-col">
          <Row align="middle" gutter={[30, 0]}>
            <Col>
              <div>
                <span className="heading-span">Student History View</span>
              </div>
            </Col>
          </Row>
        </Col>

        <Col lg={24} xl={24} xxl={24} md={24} style={{ minHeight: "70vh" }}>
          <Form component={false} className="table-style">
            <Table
              className="special-table activity-type-table project-statuses-table"
              rowClassName="editable-row"
              // dataSource={reportBatches[0]?.reports || []}
              dataSource={filteredData}
              loading={loading}
              columns={columns}
              pagination={false}
              rowKey="_id"
            />
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default HistoryView;
